import { Div, P } from '@kizi/core-components';
import * as React from 'react';
import { ModalAccordions } from './ModalAccordion';

interface InfoItem {
  id: string;
  tekst_kort: string;
  tekst_lang: string;
  type: string;
}

export interface ProviderContent {
  id: string;
  naam: string;
  alias: string;
  logo: null;
  links: null;
  website: string;
  straat: string;
  huisnummer: string;
  huisnummer_extensie: string;
  postcode: string;
  stad: string;
  opmerkingen: null;
  telefoon: string;
  comments_external: string;
  helpdesk_costs: string;
  attributes: {
    id: string;
    company_id: string;
    klantenbalies: string;
    vergunninghouder: string;
    lid_geschillencommissie: string;
    lid_gedragscode: string;
    antwoord_email: string;
    antwoord_brief: string;
    antwoord_telefoon: string;
    tijdigheid_rekening_electricity: string;
    tijdigheid_rekening_gas: string;
    signalen_klachten_algemeen: string;
    waarom_bijzonder: string;
    boete_opzeggen: string;
    boete_hoogte: string;
    acceptgiro_kosten: string;
    autoincasso_kosten: string;
    balie_kosten: string;
    betaalmogelijkheid_anders: string;
    kosten_eerste: string;
    kosten_tweede: string;
    kosten_verhuizen: string;
    kosten_overig: string;
  };
  overstap_proces: {
    business_switch: InfoItem[];
    business_move: InfoItem[];
    consument_switch: InfoItem[];
    consument_move: InfoItem[];
  };
  producten: any;
  label: any;
  betalingsMethode: null;
  terms: any[];
  extraGreen: null;
  email: null;
  logos: any[];
  dateFormat: string;
  timeZone: {
    timezone_type: number;
    timezone: string;
  };
  energieProductTypes: {
    combi: string;
    stroom: string;
    gas: string;
  };
}
interface ProductSupplierDetailsProps {
  content: ProviderContent;
  description: string;
  postcoderoosregeling: string;
}

function getAddress({
  huisnummer,
  huisnummer_extensie,
  postcode,
  stad,
  straat,
}: ProviderContent): string {
  let address = `${straat} ${huisnummer} `;

  if (huisnummer_extensie) {
    address += `${huisnummer_extensie} `;
  }

  address += `${postcode} ${stad}`;

  return address;
}

export const ProductSupplierDetails: React.FC<ProductSupplierDetailsProps> =
  React.forwardRef<HTMLDivElement, ProductSupplierDetailsProps>(
    (
      {
        content,
        description,
        postcoderoosregeling,
        ...restProps
      }: ProductSupplierDetailsProps,
      ref
    ) => {
      const { attributes, naam } = content;
      return (
        <Div {...restProps} ref={ref} variant="accordionContainer">
          <P variant="bodyRegular">{description}</P>
          <ModalAccordions
            allAreOpen
            groups={[
              {
                mt: 3,
                accordionInnerListVariant: 'accordionInnerList',
                title: 'Dienstverlening',
                fields: [
                  {
                    label: 'Beloofde beantwoording e-mail',
                    value: attributes.antwoord_email,
                  },
                  {
                    label: 'Beloofde beantwoording brief',
                    value: attributes.antwoord_brief,
                  },
                  {
                    label: 'Tijdigheid rekening elektriciteit',
                    value: attributes.tijdigheid_rekening_electricity,
                  },
                  {
                    label: 'Aantal signalen en klachten algemeen',
                    value: attributes.tijdigheid_rekening_gas,
                  },
                ],
              },
              {
                title: 'Algemene gegevens',
                accordionInnerListVariant: 'accordionInnerList',
                fields: [
                  { label: 'Handelsnaam', value: naam },
                  {
                    label: 'Adres',
                    value: getAddress(content),
                  },
                  {
                    label: 'Telefonische bereikbaarheid',
                    value: attributes.antwoord_telefoon,
                  },
                  {
                    label: 'Deelname Postcoderoosregeling',
                    icon:
                      postcoderoosregeling === 'true'
                        ? 'green-check'
                        : 'small-cancel',
                  },
                ],
              },
              {
                title: 'Juridische informatie',
                accordionInnerListVariant: 'accordionInnerList',
                fields: [
                  { label: 'Leveringsvergunning ACM', icon: 'green-check' },
                  {
                    label: 'Lid geschillencomissie energie en water',
                    icon: 'green-check',
                  },
                  {
                    label: 'Aangesloten bij EDSN/CER',
                    icon: 'green-check',
                  },
                  {
                    label:
                      'Aangesloten bij Gedragscode Consument en Energieleverancier',
                    icon: 'green-check',
                  },
                ],
              },
            ]}
          />
        </Div>
      );
    }
  );
